module.exports = __webpack_public_path__ + "img/icon3.8122c815.svg";